module.exports = __webpack_public_path__ + "static/img/IMG_0907.4adab89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0907.jpg
// module id = eGwV
// module chunks = 12